import { apiFetch } from "./api";

export async function listDigitalCertificates() {
  const response = await apiFetch("/api/digital-certificates", {
    method: "GET",
  });

  return response.certificates || [];
}

export async function uploadDigitalCertificate({
  ownerType,
  name,
  password,
  file,
}) {
  const formData = new FormData();

  formData.append("owner_type", ownerType);

  if (name) {
    formData.append("name", name);
  }

  formData.append("password", password);
  formData.append("certificate", file);

  const response = await apiFetch("/api/digital-certificates", {
    method: "POST",
    body: formData,
  });

  return response.certificate;
}

export async function deleteDigitalCertificate(id) {
  return apiFetch(`/api/digital-certificates/${id}`, {
    method: "DELETE",
  });
}
